import {
  Select,
  TextField,
  InlineGrid,
  Card,
  DataTable,
  Layout,
  ButtonGroup,
  Button,
  BlockStack,
  Text,
  InlineStack,
  Page,
  LegacyCard,
  Tag,
  InlineError,
} from "@shopify/polaris";
import { useState, useEffect, useMemo } from "react";
import Modal from "../commonComponents/modal";

import storageUtils from "../utils/storageUtils";
import {
  g_pro_t_pixel,
  c_u_pro_t_pixel,
  g_fb_settings,
  c_u_fb_setting,
  c_u_tk_pixel,
  g_tk_setting,
} from "../api";

export default function Piexl() {
  const user_token = storageUtils.get("user_token");
  const [productPixelOptions, setProductPixelOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState("");
  const [modalPOpen, setModalPOpen] = useState("");
  const [modalPLoading, setmodalPLoading] = useState(false);
  const [selectData, setSeleteData] = useState({});
  const [FBSettings, setFBSettings] = useState([]);
  const [selectPixel, setSelectPixel] = useState({});
  const [fPixel, setFPixel] = useState("");
  const [fName, setFName] = useState("");
  const [fAccessToken, setFAccessToken] = useState("");
  const [fErrorTip, setFErrorTip] = useState("");
  const [createdLoading, setCreatedLoading] = useState(false);
  const [modalFLoading, setModalFLoading] = useState(false);
  const [deLoading, setDeLoading] = useState(false);
  const [modalFOpen, setModalFOpen] = useState(false);
  const [TKSettings, setTKSettings] = useState([]);
  const [tPixel, setTPixel] = useState("");
  const [tAccessToken, setTAccessToken] = useState("");
  const [isTLoading, setIsTLoading] = useState("");
  const [pPixelMap, setPPixelMap] = useState([]);

  const queryPPixel = async () => {
    try {
      clearInput();
      const params = {
        user_token: user_token,
      };
      const response = await g_pro_t_pixel(params);
      if (!response.data) return;
      const data = response.data;
      setPPixelMap(data);
    } catch (error) {
      console.log(error);
    }
  };

  const productPixelList = useMemo(() => {
    return pPixelMap.map((item) => {
      const FBSettingPixel = FBSettings.find(
        (FB) => FB.pixel_id === item.pixel_id,
      );

      const name = FBSettingPixel?.name || item.pixel_id || "";

      return [
        item.name,
        item.product_id,
        name,
        item.type === 0 ? "Facebook" : "Tiktok",
        // 按钮逻辑：
        <Button
          variant="plain"
          key={`${item.id}-u`}
          onClick={() => updateProductToPixel(item)}
        >
          Update
        </Button>,
        <Button
          variant="plain"
          tone="critical"
          key={`${item.id}-d`}
          onClick={() => deleteProductPixel(item)}
        >
          Delete
        </Button>,
      ];
    });
  }, [pPixelMap, FBSettings]);

  const updateProductToPixel = (data) => {
    try {
      setSeleteData(data);
      setModalPOpen(true);
      handleSelectOption("pixel", data.pixel_id);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteProductPixel = async (data) => {
    const params = {
      user_token: user_token,
      id: data.id,
      is_delete: 1,
    };
    const response = await c_u_pro_t_pixel(params);
    if (response.status !== 200) return;
    initQueryData();
  };

  const handleChangeProductPixel = (key, value) => {
    setSeleteData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleCreate = () => {
    setSeleteData({});
    setModalPOpen(true);
    setSelectedOptions("");
  };

  const clearInput = () => {
    setSeleteData({});
  };

  const saveProductToPixel = async () => {
    setmodalPLoading(true);
    const params = {
      user_token: user_token,
      role_name: selectData.name,
      product_id: selectData.product_id,
      pixel_id: selectData.pixel,
      type: selectData.type ? selectData.type : "0",
    };

    if (selectData.id) params.id = selectData.id;
    const response = await c_u_pro_t_pixel(params);
    if (response.status !== 200) return;
    initQueryData();
    setModalPOpen(false);
    setmodalPLoading(false);
  };

  const options = [
    { label: "Facebook", value: "0" },
    { label: "TikTok", value: "1" },
  ];

  const queryFPixel = async () => {
    const params = {
      user_token: user_token,
    };
    const response = await g_fb_settings(params);
    if (!response.data) return;
    const data = response.data;
    setFBSettings(data);
    const fbOptions = [
      {
        label: "Please select pixels.",
        value: "",
      },
    ];
    data.forEach((item) => {
      fbOptions.push({
        label: item.name ? item.name : item.pixel_id,
        value: item.pixel_id,
      });
    });
    setProductPixelOptions(fbOptions);
  };

  const DeleteFPixel = async (id) => {
    const params = {
      user_token: user_token,
      id: selectPixel.id,
      is_delete: 1,
    };
    const response = await c_u_fb_setting(params);
    initQueryData();
    initData();
  };
  const createdOrUpdatePixel = async (isUpdate) => {
    let params = {};
    setCreatedLoading(true);
    if (isUpdate) {
      params = {
        user_token: user_token,
        id: selectPixel.id,
        name: selectPixel.name,
        pixel_id: selectPixel.pixel_id,
        access_token: selectPixel.access_token,
      };
    } else {
      params = {
        user_token: user_token,
        name: fName,
        pixel_id: fPixel,
        access_token: fAccessToken,
      };
      const created = alreadyCreate(fPixel, FBSettings);
      if (created) {
        setFErrorTip("The same Pixel ID has already been created");
        setCreatedLoading(false);
        return;
      }
    }

    const response = await c_u_fb_setting(params);
    initQueryData();
    initData();
  };

  const alreadyCreate = (pixel_id, data) => {
    return data.findIndex((item) => item.pixel_id === pixel_id) >= 0;
  };

  const initData = () => {
    setSelectPixel({});
    setFPixel("");
    setFPixel("");
    setFAccessToken("");
    setModalFOpen(false);
    setDeLoading(false);
    setModalFLoading(false);
    setCreatedLoading(false);
    setFErrorTip("");
    setFName("");
  };

  const initQueryData = () => {
    queryFPixel();
    queryTPixel();
    queryPPixel();
  };

  const handleSelectPixel = (item) => {
    setSelectPixel(item);
    setModalFOpen(true);
  };

  const handleChangeSelectPixel = (key, value) => {
    setSelectPixel((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    initQueryData();
  }, []);

  const queryTPixel = async () => {
    try {
      const params = {
        user_token: user_token,
      };
      const response = await g_tk_setting(params);
      if (!response.data) return;
      const data = response.data;
      setTKSettings(data);
    } catch (error) {
      setIsTLoading(false);
    }
  };

  const DeleteTPixel = async (id) => {
    const params = {
      user_token: user_token,
      id: id,
      is_delete: 1,
    };
    const response = await c_u_tk_pixel(params);
    initData();
    initQueryData();
  };
  const createdTPixel = async () => {
    const params = {
      user_token: user_token,
      pixel_id: tPixel,
      access_token: tAccessToken,
    };
    const response = await c_u_tk_pixel(params);
    initData();
    initQueryData();
  };

  const handleSelectOption = (key, value) => {
    handleChangeProductPixel(key, value);
    setSelectedOptions(value);
  };

  return (
    <Page>
      <Layout>
        <Layout.Section>
          <Layout.AnnotatedSection
            title="Pixel binding specifies the product."
            description="Once a pixel is bound to a specific product, the data generated by that product will only be sent to that pixel. If the product is not bound to a pixel, the data of the product will be sent to all the pixels added to the store."
          >
            <Card roundedAbove="sm">
              <InlineGrid columns="1fr auto">
                <div></div>
                <ButtonGroup>
                  <Button
                    onClick={() => {
                      handleCreate();
                    }}
                    accessibilityLabel="Preview"
                  >
                    Create
                  </Button>
                </ButtonGroup>
              </InlineGrid>
              <DataTable
                columnContentTypes={[
                  "text",
                  "text",
                  "text",
                  "text",
                  "text",
                  "text",
                ]}
                headings={[
                  "Name",
                  "Product Id",
                  "Pixel Id",
                  "Type",
                  "Action",
                  "Delete",
                ]}
                rows={productPixelList}
              />
            </Card>
          </Layout.AnnotatedSection>
          <Modal open={modalPOpen}>
            <BlockStack gap="200">
              <Text as="h2" variant="headingSm">
                {selectData
                  ? "Update a product association with Pixel"
                  : "Create a product association with Pixel"}
              </Text>
              <BlockStack gap="200">
                <BlockStack gap="200">
                  <TextField
                    value={selectData.name}
                    onChange={(value) => {
                      handleChangeProductPixel("name", value);
                    }}
                    label="Name"
                  />
                  <TextField
                    value={selectData.product_id}
                    onChange={(value) => {
                      handleChangeProductPixel("product_id", value);
                    }}
                    label="Product Id"
                  />
                  <Select
                    label="Pixel"
                    options={productPixelOptions}
                    onChange={(value) => {
                      handleSelectOption("pixel", value);
                    }}
                    value={selectedOptions}
                  />
                  <Select
                    label="type"
                    options={options}
                    onChange={(value) => {
                      handleChangeProductPixel("type", value);
                    }}
                    value={selectData.type ? selectData.type.toString() : "0"}
                  />
                </BlockStack>
              </BlockStack>
              <InlineStack align="end">
                <ButtonGroup>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setModalPOpen();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      saveProductToPixel();
                    }}
                    loading={modalPLoading}
                  >
                    Save
                  </Button>
                </ButtonGroup>
              </InlineStack>
            </BlockStack>
          </Modal>
        </Layout.Section>
        <Layout.Section>
          <>
            <Layout.AnnotatedSection
              title="Facebook Pixel"
              description="Facebook Pixel settings"
            >
              <LegacyCard sectioned>
                <InlineStack gap="200">
                  {FBSettings.map((item) => {
                    return (
                      <Tag
                        key={item.pixel_id + item.id}
                        onClick={() => handleSelectPixel(item)}
                      >
                        {item.name ? item.name : item.pixel_id}
                      </Tag>
                    );
                  })}
                </InlineStack>
                <BlockStack gap="100">
                  <TextField
                    value={fName}
                    onChange={(value) => setFName(value)}
                    label="Name"
                  />
                  <TextField
                    value={fPixel}
                    onChange={(value) => setFPixel(value)}
                    label="Pixel"
                  />
                  <TextField
                    value={fAccessToken}
                    onChange={(value) => setFAccessToken(value)}
                    label="Access Token"
                  />
                  {fErrorTip ? (
                    <InlineError message={fErrorTip} fieldID="myFieldID" />
                  ) : (
                    ""
                  )}

                  <InlineStack align="end">
                    <Button
                      submit
                      disabled={!fName || !fPixel || !fAccessToken}
                      onClick={() => {
                        createdOrUpdatePixel();
                      }}
                      loading={createdLoading}
                    >
                      Create
                    </Button>
                  </InlineStack>
                </BlockStack>
              </LegacyCard>
            </Layout.AnnotatedSection>
            <Modal open={modalFOpen}>
              <BlockStack gap="200">
                <Text as="h2" variant="headingSm">
                  Facebook pixel settings
                </Text>
                <BlockStack gap="200">
                  <BlockStack gap="200">
                    <TextField
                      value={selectPixel.name}
                      onChange={(value) => {
                        handleChangeSelectPixel("name", value);
                      }}
                      label="Name"
                    />
                    <TextField
                      value={selectPixel.pixel_id}
                      onChange={(value) => {
                        handleChangeSelectPixel("pixel_id", value);
                      }}
                      label="Pixel"
                    />
                    <TextField
                      value={selectPixel.access_token}
                      onChange={(value) => {
                        handleChangeSelectPixel("access_token", value);
                      }}
                      label="Access Token"
                    />
                  </BlockStack>
                  <InlineStack align="end">
                    <ButtonGroup>
                      <Button
                        variant="plain"
                        onClick={() => {
                          DeleteFPixel();
                        }}
                        tone="critical"
                        loading={deLoading}
                      >
                        Delete
                      </Button>
                      <Button
                        variant="secondary"
                        onClick={() => {
                          setModalFOpen();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        disabled={
                          !selectPixel.pixel_id || !selectPixel.access_token
                        }
                        variant="primary"
                        onClick={() => {
                          createdOrUpdatePixel(1);
                        }}
                        loading={modalFLoading}
                      >
                        Save
                      </Button>
                    </ButtonGroup>
                  </InlineStack>
                </BlockStack>
              </BlockStack>
            </Modal>
          </>
        </Layout.Section>
        {/* tk像素集成部分暂时隐藏 */}
        <Layout.Section>
          <Layout.AnnotatedSection
            title="TikTok Pixel"
            description="TikTok Pixel settings"
          >
            <LegacyCard sectioned>
              <InlineStack gap="200">
                {TKSettings.map((item) => {
                  return (
                    <Tag
                      key={item.pixel_id + item.id}
                      onRemove={() => {
                        DeleteTPixel(item.id);
                      }}
                    >
                      {item.pixel_id}
                    </Tag>
                  );
                })}
              </InlineStack>
              <BlockStack gap="100">
                <TextField
                  value={tPixel}
                  onChange={(value) => setTPixel(value)}
                  label="Pixel"
                />
                <TextField
                  value={tAccessToken}
                  onChange={(value) => setTAccessToken(value)}
                  label="Access Token"
                />
                <InlineStack align="end">
                  <Button
                    submit
                    disabled={!tPixel || !tAccessToken}
                    onClick={() => {
                      createdTPixel();
                    }}
                  >
                    Create
                  </Button>
                </InlineStack>
              </BlockStack>
            </LegacyCard>
          </Layout.AnnotatedSection>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
